import type { IFetchDeviceAuthResponse } from '../types/http'

export const fetchAuthDeviceInfo = (deviceId: number): Promise<{ data: IFetchDeviceAuthResponse }> => fetch(`https://ldq.ldcloud.net/auth/cph/device/info`, {
  method: 'POST',
  headers: {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  body: `deviceId=${deviceId}`
}).then(res => res.json());
